import { useMemo } from 'react'
import moment from 'moment'

export type MedicalHistoryDateRange = 'lastYear' | 'all'

export interface DateRangeConfig {
  from: string | null // ISO string or null for "all"
  to: string | null // ISO string or null for "all"
}

export const useMedicalHistoryDateRange = (
  range: MedicalHistoryDateRange = 'lastYear',
): DateRangeConfig =>
  useMemo(() => {
    if (range === 'all') {
      return { from: null, to: null }
    }

    // Default: last year
    const to = moment().toISOString()
    const from = moment().subtract(1, 'year').startOf('day').toISOString()

    return { from, to }
  }, [range])
